import { useState } from 'react';

const faqItems = [
  {
    q: '51影视真的免费吗？需要注册会员吗？',
    a: '是的，51影视完全免费！无需注册、无需登录、无需付费会员，所有综艺节目都可以直接在线观看全集。我们坚持免费服务的理念，让每一位综艺爱好者都能无障碍享受精彩内容。',
  },
  {
    q: '综艺节目更新速度怎么样？',
    a: '51影视与卫视播出保持同步更新，新一期节目播出后我们会在最快时间内上线。大部分热门综艺节目当天即可观看，更新速度在同类平台中处于领先水平。',
  },
  {
    q: '支持哪些设备观看？画质怎么样？',
    a: '51影视全面支持手机、平板、电脑等设备，自适应屏幕尺寸提供最佳观看体验。全站综艺节目支持1080P高清画质，采用智能码率调节技术，根据你的网络状况自动匹配最佳清晰度，确保流畅不缓冲。',
  },
  {
    q: '有哪些类型的综艺可以看？',
    a: '平台涵盖户外竞技真人秀（奔跑吧、极限挑战）、音乐竞演（乘风2024、天赐的声音）、喜剧脱口秀（王牌对王牌、脱口秀大会）、悬疑推理（密室大逃脱）、恋爱观察（心动的信号）、生活慢综（向往的生活）、舞蹈竞技（这就是街舞）等多元品类，满足不同观众的喜好。',
  },
  {
    q: '视频播放卡顿怎么办？',
    a: '如遇播放卡顿，可以尝试以下方法：1）切换网络环境（WiFi/移动数据）；2）降低清晰度；3）刷新页面重试；4）更换浏览器（推荐Chrome、Safari）。我们的智能CDN全球加速节点会持续优化播放体验。',
  },
  {
    q: '海外可以观看吗？有什么限制？',
    a: '51影视面向全球用户开放，海外观众同样可以免费在线观看。我们部署了全球CDN加速节点，即使在海外也能享受到流畅的播放体验。部分内容可能因版权限制在特定地区无法观看。',
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold mb-4 whitespace-nowrap">
              常见问答
            </span>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-black text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
              关于51影视你想知道的
            </h2>
            <p className="text-foreground-500 text-sm md:text-base mt-3">
              这里整理了大家最常问的问题，帮你快速了解平台
            </p>
          </div>

          <div className="space-y-3">
            {faqItems.map((item, idx) => (
              <div
                key={idx}
                className="bg-background-50 border border-background-200 rounded-2xl overflow-hidden"
              >
                <button
                  className="w-full flex items-center justify-between p-5 md:p-6 text-left cursor-pointer hover:bg-background-100 transition-colors"
                  onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
                >
                  <h3 className="text-sm md:text-base font-bold text-foreground-900 pr-4">
                    {item.q}
                  </h3>
                  <div className={`w-8 h-8 flex items-center justify-center rounded-full flex-shrink-0 transition-all ${
                    openIndex === idx
                      ? 'bg-primary-500 text-white rotate-45'
                      : 'bg-secondary-100 text-secondary-600'
                  }`}>
                    <i className="ri-add-line text-lg"></i>
                  </div>
                </button>
                {openIndex === idx && (
                  <div className="px-5 md:px-6 pb-5 md:pb-6">
                    <p className="text-foreground-600 text-sm leading-relaxed">
                      {item.a}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}